<div class="label">
  <mb-icon class="icon" icon="exchange"></mb-icon>
  <div class="text">
    <h2>
      @if (currencyCode === 'USD') {
        Ver las opciones disponibles en pesos argentinos.
      } @else {
        Comprá sin impuestos y percepciones pagando en dólares.
      }
    </h2>
  </div>
</div>
<div class="button-redirect">
  <button mb-button variant="principal" color="secondary" (click)="redirectChangeCurrency()">
    @if (currencyCode === 'USD') {
      Cambiar a pesos
    } @else {
      Cambiar a dólares
    }
  </button>
</div>
